import s from "./Error.module.css"

const Error = () => {
  return (
    <div>ERROR</div>
  )
}

export default Error;